import { isAxiosError } from 'axios';
import { isRouteErrorResponse } from 'react-router-dom';

export const is404 = (error: unknown) =>
  (isRouteErrorResponse(error) && error.status === 404) || (isAxiosError(error) && error.response?.status === 404);
